import src from '../../assets/coins/xmr.webp';

type Props = {
  size?: number;
  className?: string;
};

export function XmrIcon({ size = 44, className }: Props) {
  return (
    <img
      src={src}
      alt=""
      aria-label="XMR"
      width={size}
      height={size}
      draggable={false}
      className={`shrink-0 rounded-full object-cover ${className ?? ''}`}
      style={{ width: size, height: size }}
    />
  );
}
